module.exports = __webpack_public_path__ + "media/admin/cs_evaluation_003_lg-bd850e2d.png";